var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDescIcon = function SvgDescIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    fillRule: "evenodd",
    d: "M2.667 8a5.333 5.333 0 1 1 10.666 0A5.333 5.333 0 0 1 2.667 8M8 1.333a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 8 1.333m-.067 3.333c-.25 0-.375 0-.462.064a.3.3 0 0 0-.074.074c-.064.087-.064.212-.064.462V5.4c0 .25 0 .375.064.462q.03.043.074.074C7.558 6 7.683 6 7.933 6h.134c.25 0 .375 0 .462-.064a.3.3 0 0 0 .074-.074c.064-.087.064-.212.064-.462v-.134c0-.25 0-.375-.064-.462a.3.3 0 0 0-.074-.074c-.087-.064-.212-.064-.462-.064zm0 2.334c-.25 0-.375 0-.462.063a.3.3 0 0 0-.074.074c-.064.088-.064.213-.064.463v3.133c0 .25 0 .375.064.463q.03.043.074.073c.087.064.212.064.462.064h.134c.25 0 .375 0 .462-.064a.3.3 0 0 0 .074-.073c.064-.088.064-.213.064-.463V7.6c0-.25 0-.375-.064-.463a.3.3 0 0 0-.074-.074C8.442 7 8.317 7 8.067 7z",
    clipRule: "evenodd"
  })));
};
export default SvgDescIcon;